import { Directive, ElementRef, Renderer, AfterViewInit} from '@angular/core';
import { ActivatedRoute, Params, Router }   from '@angular/router';

@Directive({
  selector: '[activeTab]'
})
export class ActiveTabDirective implements AfterViewInit {
  el: ElementRef;
  renderer: Renderer;
  activeTab = 'Concordance';

  constructor(route: ActivatedRoute, el: ElementRef, renderer: Renderer) {
    route.queryParams.subscribe(params => {
      if ('tab' in params) {
        this.activeTab = params['tab'];
      }
    });
    this.el = el;
    this.renderer = renderer;
  }

  ngAfterViewInit() {
    const kids = this.el.nativeElement.children;
    for (const element in kids) {
      if (kids[element].innerHTML && (kids[element].innerHTML.toLowerCase() === this.activeTab.toLowerCase())) {
        let el = kids[element];
        this.renderer.setElementClass(el, 'active', true);
        const index = el.dataset['tab'];
        // TODO find out what to cast to and add class
        const tabs = this.el.nativeElement.parentNode.querySelectorAll('.tab');
        for (const tabIndex in tabs) {
          if (tabs[tabIndex].dataset && tabs[tabIndex].dataset['tab'] === index) {
            this.renderer.setElementClass(tabs[tabIndex], 'active', true);
          }
        }
      }
    };
  }

}



// WEBPACK FOOTER //
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/app/active-tab.directive.ts